import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Image, Stack, Nav, Container, Form, Dropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { switchProfile } from 'src/api/authService'
import collapse_icon from 'src/assets/images/collapse-title-icon.svg'
import title_icon from 'src/assets/images/title-icon.svg'
import up_icon from 'src/assets/images/up-arrow.svg'
import right_icon from 'src/assets/images/right-arrow.svg'
import add_profile_icon from 'src/assets/images/add-profile.svg'
import profile_icon from 'src/assets/images/user-icon.svg'
import {
  studentNavItems,
  teacherNavItems,
  adminNavItems,
  verifierNavItems,
} from 'src/utils/constants'

const Sidenav = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const userDetails = useSelector((state) => state.userDetails)
  const [visible, setVisible] = useState(false)
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const token = window.localStorage.getItem('token')
  const [activeAccountInfo, setActiveAccountInfo] = useState({})
  const [profiles, setProfiles] = useState([])
  const { profileType, firstName, lastName, profileIcon } = activeAccountInfo || {}
  const [sideNavItems, setSideNavItems] = useState([])
  const handleLogOut = () => {
    window.localStorage.removeItem('token')
    window.localStorage.setItem('logout-event', Date.now().toString())
    dispatch({ type: '', res: [] })
    navigate('/')
  }

  const handleToggle = () => {
    setDropdownVisible(!dropdownVisible)
  }

  useEffect(() => {
    if (!token) handleLogOut()
    else {
      setActiveAccountInfo(userDetails[0])
      setProfiles(userDetails)
    }
  }, [userDetails])
  const handleSwitchProfile = async (details) => {
    const res = await switchProfile(details?.key)
    if (res?.status === 'SUCCESS') {
      window.localStorage.setItem('token', res?.token)
      dispatch({ type: 'set', res: res?.profiles || [] })
      setDropdownVisible(false)
      setVisible(false)

      const routeMap = {
        Admin: '/admin',
        Verifier: '/verifier',
        Student: '/student',
        Teacher: '/teacher',
      }

      navigate(routeMap[details.profileType] || '/login')
    }
  }
  const handleAccountSelect = () => {
    navigate('/add-profile')
  }

  useEffect(() => {
    if (!token) handleLogOut()
    else {
      setActiveAccountInfo(userDetails[0])
      setProfiles(userDetails)
    }
  }, [userDetails])

  useEffect(() => {
    if (profileType === 'Admin') setSideNavItems(adminNavItems)
    else if (profileType === 'Verifier') setSideNavItems(verifierNavItems)
    else if (profileType === 'Student') setSideNavItems(studentNavItems)
    else if (profileType === 'Teacher') setSideNavItems(teacherNavItems)
  }, [profileType])

  return (
    <>
      <Stack className="d-none d-md-block">
        <Stack
          className={`align-items-start sidenav-content ${visible ? 'expanded' : 'collapsed'} overflow-hidden`}
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={() => {
            setDropdownVisible(false)
            setVisible(false)
          }}
        >
          <Stack direction="horizontal" className="header ps-10">
            <div className="text-truncate d-flex align-items-center">
              <Image className="z-1" src={collapse_icon} alt="Collapse Icon" />
              {visible && <Image className="img-margin" src={title_icon} alt="Title Icon" />}
            </div>
          </Stack>

          <Stack gap={10} className="align-items-start pt-20 w-100">
            {sideNavItems.map((item, index) => (
              <Nav.Link
                key={index}
                as={Link}
                to={item.to}
                className="ps-10 d-flex nav-link nav-item gap-10 align-items-center"
              >
                <span className={`nav-icon ${pathname === item.to ? 'active' : ''}`}>
                  <Image src={item.icon} alt={item.title} />
                </span>
                {visible && <span className="sidebar-text fs-16 text-white">{item.title}</span>}
              </Nav.Link>
            ))}
          </Stack>

          <Container fluid className="sidebar-profile ps-0 ">
            <Dropdown show={dropdownVisible} onToggle={handleToggle} align="end" drop="up">
              <Dropdown.Toggle
                className={`${dropdownVisible ? 'bg-dark-green' : ''}`}
                variant="none"
                id="dropdown-menu-align-end"
              >
                <Stack gap={15} className="align-items-start">
                  {dropdownVisible && (
                    <Stack direction="horizontal" gap={10}>
                      <div
                        role="button"
                        className="small-btn white-border-btn"
                        onClick={() => navigate(`/${profileType.toLowerCase()}/profile`)}
                      >
                        View Profile
                      </div>

                      <div
                        className="small-btn white-border-btn"
                        role="button"
                        onClick={handleLogOut}
                      >
                        Logout
                      </div>
                    </Stack>
                  )}

                  <Stack
                    direction="horizontal"
                    gap={10}
                    className="align-items-center w-100 cursor-pointer ps-0"
                    onClick={() => setDropdownVisible(true)}
                  >
                    <Image
                      src={profileIcon || profile_icon}
                      roundedCircle
                      className="profile-image"
                    />

                    {visible && (
                      <>
                        <Stack className="align-items-start">
                          <Form.Text className="sidebar-text  text-white text-truncate text-wrap text-start text-break">
                            {firstName} {lastName}
                          </Form.Text>

                          <Form.Text className="profile-type text-white text-truncate">
                            {profileType === 'Teacher' && activeAccountInfo?.canVerifyTests
                              ? `${profileType} (v)`
                              : profileType}
                          </Form.Text>
                        </Stack>

                        <Image className="ms-auto" src={up_icon} alt="up Icon" />
                      </>
                    )}
                  </Stack>
                </Stack>
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown-menu">
                <Stack gap={10} className="align-items-start">
                  <div onClick={handleAccountSelect} role="button">
                    <Stack direction="horizontal" gap={10} className="align-items-center px-2 py-1">
                      <Image src={add_profile_icon} />
                      <span className="sidebar-text text-truncate text-white text-wrap">
                        Add Profile
                      </span>
                    </Stack>
                  </div>
                  {profiles
                    .filter((ele) => ele.key !== activeAccountInfo?.key)
                    .map((ele) => (
                      <div
                        role="button"
                        className="w-100"
                        key={ele?.key}
                        onClick={() => handleSwitchProfile(ele)}
                      >
                        <Stack
                          direction="horizontal"
                          gap={10}
                          className="align-items-center px-2 py-1 nav-link nav-item"
                        >
                          <Image
                            src={ele.profileIcon || profile_icon}
                            roundedCircle
                            className="profile-image "
                          />
                          <Stack className="align-items-start flex-grow-1">
                            <span className="sidebar-text text-white text-truncate text-wrap">
                              {ele.firstName} {ele.lastName}
                            </span>
                            <small className="profile-type text-white text-truncate">
                              {ele?.profileType === 'Teacher' && ele?.canVerifyTests
                                ? `${ele?.profileType} (v)`
                                : ele?.profileType}
                            </small>
                          </Stack>
                          <Image className="ms-auto" src={right_icon} />
                        </Stack>
                      </div>
                    ))}
                </Stack>
              </Dropdown.Menu>
            </Dropdown>
          </Container>
        </Stack>
      </Stack>
    </>
  )
}

export default Sidenav
